<template>
    <div class="container" :style="containerStyleObj">
        <Row class="title-wrap" :style="titleWrapStyleObj" ref="titleWrap">
            <Col
                    :xs="{ span: 24 }"
                    :sm="{ span: 24 }"
                    :md="{ span: 24 }"
                    :lg="{ span: 24 }"
            >
            <div class="title" :style="titleStyleObj">
                <img src="../../assets/images/databoard/head-left-icon.png"/>
                <span v-on:click="handleFullScreen()">上虞区教育云大数据</span>
                <img src="../../assets/images/databoard/head-right-icon.png"/>
            </div>
            <div class="logo" :style="logoStyleObj">
                <img :src="`${logoPath}?${timestamp}`"/>
                <span class="split-line"></span>
                <img
                        src="../../assets/images/databoard/ai-logo.png"
                        style="margin: 3.5px 0"
                />
            </div>
            <div class="full-screen" v-on:click="handleFullScreen()">
                <template v-if="!fullscreen">
            <span class="full-icon"
            ><img src="../../assets/images/databoard/full-screen-icon.png"
            /></span>
                    <span class="full-title">全屏</span>
                </template>
                <template v-else>
            <span class="full-icon"
            ><img
                    src="../../assets/images/databoard/exit-full-screen-icon.png"
            /></span>
                    <span class="full-title">取消全屏</span>
                </template>
            </div>
            </Col>
        </Row>
        <Row class="statistic-wrap" :style="statisticWrapStyleObj">
            <Col
                    :xs="{ span: 6 }"
                    :sm="{ span: 6 }"
                    :md="{ span: 6 }"
                    :lg="{ span: 6 }"
             style="height:100%;">
            <img src="https://fs.iclass30.com/aliba/resource/region/shangyu/shangyudataleft.png" class="sy-img">
            </Col>
            <Col
                    :xs="{ span: 12 }"
                    :sm="{ span: 12 }"
                    :md="{ span: 12 }"
                    :lg="{ span: 12 }"
                    style="height:100%;"
            >
            <img src="https://fs.iclass30.com/aliba/resource/region/shangyu/shangyudatacenter.png" class="sy-img" @click="gotoSchool">
            <!--气泡1-->
            <div class="sy-rate-popup-one" title="76">
                <div class="rate-popup-item">
                    <img
                            src="../../assets/images/nanjindataboard/popup-ratate.png"
                            width="100%"
                            height="100%"
                            class="popup-img"
                    />
                    <div class="count">
        <span class="num">
        <count-up
                class="infor-card-count user-created-count"
                :id-name="'code_' + '学校总数'"
                :end-val="'76'"
                color="#0EFCFF"
                countSize="18"
                :countWeight="countWeight"
                :isConvert="isConvert"
        >
        </count-up>
        </span>
                        <p>学校总数</p>
                    </div>
                </div>
            </div>
            <!--气泡2-->
            <div class="sy-rate-popup-two" title="1000">
                <div class="rate-popup-item">
                    <img
                            src="../../assets/images/nanjindataboard/popup-ratate.png"
                            width="100%"
                            height="100%"
                            class="popup-img"
                    />
                    <div class="count">
        <span class="num">
        <count-up
                class="infor-card-count user-created-count"
                :id-name="'code_' + '班级总数'"
                :end-val="'1000'"
                color="#0EFCFF"
                countSize="18"
                :countWeight="countWeight"
                :isConvert="isConvert"
        >
        </count-up>
        </span>
                        <p>班级总数</p>
                    </div>
                </div>
            </div>
            <!--气泡3-->
            <div class="sy-rate-popup-three" title="4000">
                <div class="rate-popup-item">
                    <img
                            src="../../assets/images/nanjindataboard/popup-ratate.png"
                            width="100%"
                            height="100%"
                            class="popup-img"
                    />
                    <div class="count">
        <span class="num">
        <count-up
                class="infor-card-count user-created-count"
                :id-name="'code_' + '学生总数'"
                :end-val="'4000'"
                color="#0EFCFF"
                countSize="18"
                :countWeight="countWeight"
                :isConvert="isConvert"
        >
        </count-up>
        </span>
                        <p>学生总数</p>
                    </div>
                </div>
            </div>
            <!--气泡4-->
            <div class="sy-rate-popup-four" title="3540">
                <div class="rate-popup-item">
                    <img
                            src="../../assets/images/nanjindataboard/popup-ratate.png"
                            width="100%"
                            height="100%"
                            class="popup-img"
                    />
                    <div class="count">
        <span class="num">
        <count-up
                class="infor-card-count user-created-count"
                :id-name="'code_' + '教师总数'"
                :end-val="'3540'"
                color="#0EFCFF"
                countSize="18"
                :countWeight="countWeight"
                :isConvert="isConvert"
                style="height:100%;"
        >
        </count-up>
        </span>
                        <p>教师总数</p>
                    </div>
                </div>
            </div>
            </Col>
            <Col
                    :xs="{ span: 6 }"
                    :sm="{ span: 6 }"
                    :md="{ span: 6 }"
                    :lg="{ span: 6 }"
                    style="height:100%;"
            >
            <img src="https://fs.iclass30.com/aliba/resource/region/shangyu/shangyudataright.png" class="sy-img">
            </Col>
        </Row>
    </div>
</template>

<script>
    import CountUp from "@/components/countUp.vue";

    export default {
        name: "sy-area-databoard",
        components: {
            CountUp, //数据卡片
        },
        computed: {},
        data() {
            return {
                isConvert: 1, //是否转换数字
                fullscreen: false,
                schoolData: {},
                newSchoolData: {},
                evlPer: 80,
                teaCourseware: [], //教师课件
                stuHomework: [], //学生作业
                teaClassBehavior: [], //教师课堂行为
                dynamicData: [], //实时动态
                baseData: [], //基础数据
                classInteractData: [], //课堂互动
                classInteractTotal: 0, //课堂互动总数
                teaBehaviorData: [], //教师行为
                stuBehaviorData: [], //学生行为
                ebookCountList: [], //校本书库
                top: [],
                left: [130, 140, 150, 160, 170, 180, 190, 200, 210, 230],
                color: ["#FFF", "#00d8ff", "#ffce23"],
                scrollInterval: {}, //动态滚动区间,
                scrollIngDynamicList: [],
                screenHeight: document.body.clientHeight, // 屏幕默认宽度
                containerStyleObj: {
                    height: "",
                },
                titleWrapStyleObj: {
                    height: "",
                },
                titleStyleObj: {
                    height: "",
                },
                logoStyleObj: {
                    height: "",
                },
                statisticWrapStyleObj: {
                    height: "",
                    margin: "0px 0px 10px 0px",
                },
                statisCountStyleObj: {
                    height: "",
                },
                numStyleObj: {
                    height: "",
                    lineHeight: "",
                },
                nameStyleObj: {
                    height: "",
                    lineHeight: "",
                },
                teaOperDymStyleObj: {
                    height: "",
                },
                dymContentStyleObj: {
                    height: "",
                },
                teaCoursewareCount: "", //教师课件总数
                titleHeight: 0,
                countWeight: 700,
                previewMode: false,
                previewVideoMode: false,
                videoSrc: "",
                isShowModal: false,
                currentInter: {},
                tabsName: "", //标签页名称
                schoolId: this.$route.params.schoolId, //学校id
                logoPath: process.env.VUE_APP_DASH_LOGO_PATH,
                yjtLogoPath: process.env.VUE_APP_DASH_YJT_LOGO_PATH,
                timestamp: new Date().getTime(),
                channel: process.env.VUE_APP_CHANNEL,
            };
        },
        created() {
        },
        watch: {},
        methods: {
            /**
             * 全屏
             */
            handleFullScreen() {
                let element = document.documentElement;
                if (this.fullscreen) {
                    if (document.exitFullscreen) {
                        document.exitFullscreen();
                    } else if (document.webkitCancelFullScreen) {
                        document.webkitCancelFullScreen();
                    } else if (document.mozCancelFullScreen) {
                        document.mozCancelFullScreen();
                    } else if (document.msExitFullscreen) {
                        document.msExitFullscreen();
                    }
                } else {
                    if (element.requestFullscreen) {
                        element.requestFullscreen();
                    } else if (element.webkitRequestFullScreen) {
                        element.webkitRequestFullScreen();
                    } else if (element.mozRequestFullScreen) {
                        element.mozRequestFullScreen();
                    } else if (element.msRequestFullscreen) {
                        // IE11
                        element.msRequestFullscreen();
                    }
                }
                this.fullscreen = !this.fullscreen;
            },
            /**
             * @name 查看对应学校
             */
            gotoSchool(){
                let routeData = this.$router.resolve({
                    name: "schooldataboard",
                    params: {
                        schoolId: '9a78893ef86411e8b8cc00e04c83698'
                    },
                    query:{
                        origin:'chart',
                        tokenId:this.$store.getters.token
                    }
                });
                window.open(routeData.href, "_blank");
            }
        },
        mounted() {
            const _this = this;
            this.$nextTick(() => {
                let windowHeight = window.innerHeight;
                if (windowHeight < 900) {
                    windowHeight = 938;
                    document.getElementsByTagName("body")[0].className = "active";
                }
                let titleHeight = 128;
                let statisticHeight = windowHeight - titleHeight - 10;
                let statisHeight = windowHeight / 12.5;
                let dymHeight = statisticHeight - statisHeight - statisticHeight / 3 - 20;
                this.titleHeight = titleHeight;
                this.containerStyleObj.height = windowHeight + "px";
                this.titleWrapStyleObj.height = titleHeight + "px";
                this.titleStyleObj.height = titleHeight * 0.4 - 10 + "px";
                this.logoStyleObj.height = titleHeight * 0.3 + "px";
                this.statisticWrapStyleObj.height = statisticHeight + "px";
                this.statisCountStyleObj.height = statisHeight + "px";
                this.numStyleObj.height = statisHeight * 0.6 + "px";
                this.numStyleObj.lineHeight = statisHeight * 0.6 + "px";
                this.nameStyleObj.height = statisHeight * 0.4 + "px";
                this.nameStyleObj.lineHeight = statisHeight * 0.4 + "px";
                this.teaOperDymStyleObj.height = dymHeight + "px";
                this.dymContentStyleObj.height = dymHeight - 49 + "px";
            });

            // 注：window.onresize只能在项目内触发1次
            window.onresize = function windowResize() {
                // 通过捕获系统的onresize事件触发我们需要执行的事件
                let windowHeight = document.body.clientHeight;
                if (windowHeight < 900) {
                    windowHeight = 938;
                    document.getElementsByTagName("body")[0].className = "active";
                }
                _this.screenHeight = windowHeight;
                let titleHeight = 128;
                let statisticHeight = windowHeight - titleHeight - 10;
                let statisHeight = windowHeight / 12.5;
                let dymHeight = statisticHeight - statisHeight - statisticHeight / 3 - 20;
                _this.titleHeight = titleHeight;
                _this.titleHeight = titleHeight;
                _this.containerStyleObj.height = windowHeight + "px";
                _this.titleWrapStyleObj.height = titleHeight + "px";
                _this.titleStyleObj.height = titleHeight * 0.4 - 10 + "px";
                _this.logoStyleObj.height = titleHeight * 0.3 + "px";
                _this.statisticWrapStyleObj.height = statisticHeight + "px";
                _this.statisCountStyleObj.height = statisHeight + "px";
                _this.numStyleObj.height = statisHeight * 0.6 + "px";
                _this.numStyleObj.lineHeight = statisHeight * 0.6 + "px";
                _this.nameStyleObj.height = statisHeight * 0.4 + "px";
                _this.nameStyleObj.lineHeight = statisHeight * 0.4 + "px";
                _this.teaOperDymStyleObj.height = dymHeight + "px";
                _this.dymContentStyleObj.height = dymHeight - 49 + "px";
            };
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../style/databoard";
    @import "../../style/detailPage";

    /*.container{*/
        /*overflow-y: auto;*/
    /*}*/
    .panel-box {
        background-image: url("../../assets/images/databoard/modal-bg.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
    }

    @font-face {
        font-family: MaravaleExpanded;
        src: url("../../assets/fonts/digifaw.ttf"); //字体路径
    }

    .container {
        background-image: url("../../assets/images/databoard/bg.png");
        background-size: cover;
        background-repeat: no-repeat;
    }

    .title-wrap {
        background-image: url("../../assets/images/databoard/head-bg.png");
        background-repeat: no-repeat;
        background-position: top;
    }

    .count-wrap {
        height: 100%;
        background-image: url("../../assets/images/databoard/count-bg.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
    }

    .full-screen {
        background-image: url("../../assets/images/databoard/full-screen-bg.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
    }

    .statis-report {
        background-image: url("../../assets/images/databoard/full-screen-bg.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
    }

    .bg1 {
        background-image: url("../../assets/images/databoard/title-bg1.png");
    }

    .sy-rate-popup-one {
        position: absolute;
        top: vw(90);
        left: vw(60);
    }

    .sy-rate-popup-two {
        position: absolute;
        top: vw(580);
        left: vw(55);
    }

    .sy-rate-popup-three {
        position: absolute;
        top: vw(73);
        right: vw(80);
    }

    .sy-rate-popup-four {
        position: absolute;
        top: vw(510);
        right: vw(6);
    }

    .rate-popup-item {
        position: relative;
        .count {
            width: 100%;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: vw(12);
            color: #0EFCFF;
        }
        .num {
            font-family: MaravaleExpanded;
            font-size: vw(40);
        }
    }

    .popup-img {
        width: vw(185);
        height: vw(185);
        animation: rota 10s infinite linear;
        -webkit-animation: rota 10s infinite linear;
        -moz-animation: rota 10s infinite linear;
    }

    .sy-img {
        width: 100%;
        height: 100%;
    }
</style>

<style lang="scss">
    body {
        background-color: #000 !important;
        overflow-x: hidden;
        overflow-y: hidden;
    }

    .active {
        overflow-x: auto;
        overflow-y: auto;
    }
</style>
